import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";

import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {ICameraLive, ICameraPayload, ICameraPayloadSound} from "../../store/sliceCamera";
import {CloseButton, Microfone, VideoContainer, VideoImg} from "./Style";
import {Spinner} from "react-bootstrap";
import {VolumeMute, VolumeUp, XSquareFill} from "react-bootstrap-icons";
import {actions as actionCamera} from "../../store/sliceCamera";
import {actions as modal} from "../../store/sliceModal";
import {getCamImage} from "../../utils/selectors";

type CameraImageProps = {
    name: string,
    isClose: boolean,
    sound: boolean,
    onHide?: () => void,

}
const CameraImage: FC<CameraImageProps> = ({name, isClose, onHide, sound})  => {
    const dispatch = useDispatch<AppDispatch>();
   const camera: ICameraLive = useSelector((state) => getCamImage(state, name))

    // const camera: ICameraLive = useSelector((state: IRootState) => state.websocketCamera.cameras.filter((cam1: ICameraLive) => cam1.name == name)[0])
    const [load, setLoad] = useState<boolean>(true);

    const loading =  !camera?.error && !camera?.image?.length && load;
    const translation = !camera?.error && !loading && load;


    const close = useCallback(() => {
        if (onHide) {
            setLoad(false)
            onHide()
            dispatch(actionCamera.clear({name: name} as ICameraPayload))

        }
    }, [onHide])

    const onMute = useCallback(() => {
        dispatch(actionCamera.setSound({name: name, sound: !camera.sound} as ICameraPayloadSound ))
    }, [camera?.sound])

    useEffect(() => {
        if (sound && camera?.error) {
            dispatch(modal.showError(camera?.error))
            close()
        }
    }, [sound, camera?.error])

    return (
        <VideoContainer>
            {camera?.error && <p>{camera?.error}</p>}
            {loading  && <Spinner variant={"primary"}/>}
            {translation && <VideoImg src={`data:image/jpeg;base64,${camera?.image}`}/>}
            {isClose && load && <CloseButton onClick={() => close()}>
                {translation && <XSquareFill style={{backgroundColor: "white"}} size={25}></XSquareFill>}
            </CloseButton>}
            {sound && translation && <Microfone onClick={onMute}>
                {!camera?.sound && <VolumeMute size={35}></VolumeMute>}
                {camera?.sound && <VolumeUp size={35}></VolumeUp>}
            </Microfone>}
        </VideoContainer>
    )

}

export default memo(CameraImage)
